import { ActionMenu } from "@telluscompany/design-system";
import { Edit, MoreVerticalIcon, Trash2 } from "lucide-react";

import { useLocalization } from "@i18n";
import { ListUsersManagerialResponse } from "../../api/user";

interface UsersActionMenuProps {
  user: ListUsersManagerialResponse;
  onEdit: (user: ListUsersManagerialResponse) => void;
  onDelete: (user: ListUsersManagerialResponse) => void;
}

export const UsersActionMenu = ({
  user,
  onEdit,
  onDelete,
}: UsersActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("management.users.button.edit"),
          onClick: () => onEdit(user),
          icon: <Edit size={16} />,
        },
        {
          label: translate("management.users.button.delete"),
          onClick: () => onDelete(user),
          icon: <Trash2 size={16} />,
          colorTitle: "red" as const,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVerticalIcon />} />;
};
